import script from "./doctorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorCard.vue?vue&type=script&setup=true&lang=js"

import "./doctorCard.vue?vue&type=style&index=0&id=7b1eac18&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1eac18"]])

export default __exports__